<template>
  <nav>
    <v-app-bar dark
               app
               color="primary">

      <a class="ml-2 mt-2"
         href="https://lp.proxpect.com.br/fornecedores/"
         target="_blank"
         rel="noopener noreferrer">
        <img class="header-logo" src="../../assets/logo-branca.png"
             alt="Logo da Proxpect"/>
      </a>
      <v-spacer/>
    </v-app-bar>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
  .header-logo {
    height: 40px;
    cursor: pointer;
  }
</style>
